import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export function useAnalytics() {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    const trackPageView = async () => {
      try {
        await fetch(`${API}/analytics/track`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            event_type: 'page_view',
            page: location.pathname,
            metadata: {
              referrer: document.referrer,
              timestamp: new Date().toISOString()
            }
          })
        });
      } catch (error) {
        // Silently fail - don't break the app for analytics
        console.debug('Analytics tracking failed:', error);
      }
    };

    trackPageView();
  }, [location.pathname]);
}

export function trackEvent(eventType, metadata = {}) {
  try {
    fetch(`${API}/analytics/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        event_type: eventType,
        page: window.location.pathname,
        metadata
      })
    });
  } catch (error) {
    console.debug('Event tracking failed:', error);
  }
}
